import type { FaireProductEntity } from "../../entity_types/product";

export const p_28285brrrj: FaireProductEntity = {
  token: "p_28285brrrj",
  type: "product",
  name: "Sugar Scrub - Vanilla Coconut 8oz",
  brandName: "Deep Steep Clean Beauty",
  imageUrl:
    "https://cdn.faire.com/fastly/9ec5348c9da8b6c06ca758e0ea30a1477c521a32ea59f1762ba6dc96b06ef0ec.jpeg",
  priceDollars: 8.97,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/17b1f26fd58aec581480ae2c704d17444b8a074823aab14d2cdc770a59af613c.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
